import Stack from '~/common/components/Stacks/Stack/index';

const ModalFooter = ({
  children,
  sx,
  ...props
}: Readonly<React.ComponentProps<typeof Stack>>) => {
  return (
    <Stack
      className="mui-modal-footer"
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-around',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
};

export default ModalFooter;
